interface DineInDishCardProps {
  number?: string;
  name: string;
  description?: string;
  price?: string;
  variants?: string;
  allergens?: string;
}

const DineInDishCard = ({ number, name, description, price, variants, allergens }: DineInDishCardProps) => {
  return (
    <div className="group relative py-3 sm:py-4 px-1 sm:px-2 rounded-lg transition-all duration-300 hover:bg-gold/5 border-b border-gold/10 last:border-b-0">
      <div className="flex items-start gap-2 sm:gap-3">
        {number && (
          <span className="flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8 flex items-center justify-center rounded-full bg-gold/10 text-gold font-display text-xs sm:text-sm font-semibold group-hover:bg-gold/20 group-hover:scale-110 transition-all duration-300">
            {number}
          </span>
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-baseline flex-wrap gap-x-3 gap-y-0.5 mb-1">
            <h4 className="font-elegant text-sm sm:text-base lg:text-lg text-foreground group-hover:text-gold transition-colors duration-300">
              {name}
            </h4>
            {variants && (
              <span className="text-xs sm:text-sm text-gold font-semibold font-display tracking-wide ml-auto" style={{
                textShadow: '0 0 15px hsl(var(--gold) / 0.3)'
              }}>
                {variants}
              </span>
            )}
          </div>
          {description && (
            <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed mb-2">
              {description}
            </p>
          )}
          {allergens && (
            <p className="text-[10px] sm:text-xs text-gold/70 italic font-sans">
              Allergener: {allergens}
            </p>
          )}
        </div>
        {!variants && price && (
          <div className="flex-shrink-0 ml-2 sm:ml-3 lg:ml-4">
            <span className="font-display text-sm sm:text-base lg:text-lg text-gold font-semibold group-hover:scale-110 inline-block transition-transform duration-300" style={{
              textShadow: '0 0 20px hsl(var(--gold) / 0.3)'
            }}>
              {price} kr
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DineInDishCard;
